import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchAffiliateDashboard,
  fetchAffiliateDashboardSixMonth,
  fetchAffiliateDashboardData,
  fetchAffiliateReservations,
  initializeAffiliateDashboardScreen,
} from "../../../redux/actions/Affiliate/affiliateDashboard";
import { fetchLocationDD } from "../../../redux/actions/location";
import { fetchAffiliateDD } from "../../../redux/actions/Affiliate/affiliate";
import AffiliateDashboard from "../../../component/Affiliate/AffiliateDashboard";
import { loadingShow } from "../../../services/PostAPI";
import { APP_URLS } from "../../../utils/constant";

function AffiliateDashboardScreen(props) {
  const {
    fetchAffiliateDashboard,
    fetchAffiliateDashboardSixMonth,
    fetchAffiliateDashboardData,
    fetchAffiliateReservations,
    initAffiliateDashboardScreen,
    fetchLocationDD,
    fetchAffiliateDD,
    showPageLevelLoader,
    totalAffiliates,
    activeAffiliates,
    affiliateMetrics,
    sixMonthMetrics,
    isSixMonthLoading,
    performanceMetrics,
    performancePaginationInfo,
    isPerformanceLoading,
    affiliateReservations,
    isLoadingReservations,
    isLoading,
    isPageLevelError,
    screenPermissions,
    locationDD,
    affiliateDD,
  } = props;

  const navigate = useNavigate();

  const [selectedLocationIds, setSelectedLocationIds] = useState([]);
  const [selectedAffiliateIds, setSelectedAffiliateIds] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(30);

  const handleTotalAffiliatesClick = () => {
    navigate(APP_URLS.AFFILIATE.HOME);
  };

  const handleActiveAffiliatesClick = () => {
    navigate(APP_URLS.AFFILIATE.HOME, { state: { statusFilter: "Active" } });
  };

  useEffect(() => {
    initAffiliateDashboardScreen();
    fetchLocationDD();
    fetchAffiliateDD();
    fetchAffiliateDashboard({ period: 30 });
    fetchAffiliateDashboardSixMonth();
    fetchAffiliateDashboardData({ pageNumber: 0, pageSize: 10 });
  }, []);

  const handlePerformancePageChange = (params) => {
    fetchAffiliateDashboardData({
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
    });
  };

  const handleLocationChange = (locationIds) => {
    setSelectedLocationIds(locationIds);
    fetchAffiliateDashboard({
      locationId: locationIds,
      affiliateId: selectedAffiliateIds,
      period: selectedPeriod,
    });
    fetchAffiliateDashboardSixMonth({
      locationId: locationIds,
      affiliateId: selectedAffiliateIds,
    });
    fetchAffiliateDashboardData({
      pageNumber: 0,
      pageSize: performancePaginationInfo?.size || 10,
    });
  };

  const handleAffiliateChange = (affiliateIds) => {
    setSelectedAffiliateIds(affiliateIds);
    fetchAffiliateDashboard({
      locationId: selectedLocationIds,
      affiliateId: affiliateIds,
      period: selectedPeriod,
    });
    fetchAffiliateDashboardSixMonth({
      locationId: selectedLocationIds,
      affiliateId: affiliateIds,
    });
    fetchAffiliateDashboardData({
      pageNumber: 0,
      pageSize: performancePaginationInfo?.size || 10,
    });
  };

  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
    fetchAffiliateDashboard({
      locationId: selectedLocationIds,
      affiliateId: selectedAffiliateIds,
      period: period,
    });
  };

  const dashboardProps = {
    totalAffiliates,
    activeAffiliates,
    affiliateMetrics,
    sixMonthMetrics,
    isSixMonthLoading,
    isLoading,
    isPageLevelError,
    screenPermissions,
    locationDD: locationDD || [],
    affiliateDD: affiliateDD || [],
    selectedLocationIds,
    selectedAffiliateIds,
    onLocationChange: handleLocationChange,
    onAffiliateChange: handleAffiliateChange,
    onPeriodChange: handlePeriodChange,
    onTotalAffiliatesClick: handleTotalAffiliatesClick,
    onActiveAffiliatesClick: handleActiveAffiliatesClick,
    performanceMetrics,
    performancePaginationInfo,
    isPerformanceLoading,
    onPerformancePageChange: handlePerformancePageChange,
    affiliateReservations,
    isLoadingReservations,
    onFetchReservations: fetchAffiliateReservations,
  };

  loadingShow("none");

  return (
    <div>
      <AffiliateDashboard {...dashboardProps} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initAffiliateDashboardScreen: () => dispatch(initializeAffiliateDashboardScreen()),
    fetchAffiliateDashboard: (payload) => dispatch(fetchAffiliateDashboard(payload)),
    fetchAffiliateDashboardSixMonth: (payload) => dispatch(fetchAffiliateDashboardSixMonth(payload)),
    fetchAffiliateDashboardData: (payload) => dispatch(fetchAffiliateDashboardData(payload)),
    fetchAffiliateReservations: (payload) => dispatch(fetchAffiliateReservations(payload)),
    fetchLocationDD: () => dispatch(fetchLocationDD()),
    fetchAffiliateDD: () => dispatch(fetchAffiliateDD()),
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    showPageLevelLoader: state.affiliateDashboardReducer?.isLoadingPage,
    totalAffiliates: state.affiliateDashboardReducer?.totalAffiliates || 0,
    activeAffiliates: state.affiliateDashboardReducer?.activeAffiliates || 0,
    affiliateMetrics: state.affiliateDashboardReducer?.affiliateMetrics || [],
    sixMonthMetrics: state.affiliateDashboardReducer?.sixMonthMetrics || [],
    isSixMonthLoading: state.affiliateDashboardReducer?.isSixMonthLoading || false,
    performanceMetrics: state.affiliateDashboardReducer?.performanceMetrics || [],
    performancePaginationInfo: state.affiliateDashboardReducer?.performancePaginationInfo,
    isPerformanceLoading: state.affiliateDashboardReducer?.isPerformanceLoading || false,
    affiliateReservations: state.affiliateDashboardReducer?.affiliateReservations || {},
    isLoadingReservations: state.affiliateDashboardReducer?.isLoadingReservations || {},
    isLoading:
      state.affiliateDashboardReducer?.isLoadingPage ||
      state.affiliateDashboardReducer?.isLoading,
    isPageLevelError: state.affiliateDashboardReducer?.isPageLevelError,
    locationDD: state.locationReducer?.locationDD || [],
    affiliateDD: state.affiliateReducer?.affiliateDD || [],
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AffiliateDashboardScreen);
